import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {BasicLabManagerItemModel} from "../models/lab-manager/basic-lab-manager-item";
import {AgronimistModel} from "../models/lab-manager/agronimist";
import {LabCostItemModel} from "../models/lab-manager/lab-cost-item";

@Injectable({
    providedIn: 'root'
})
export class LabManagerSharedDataService {
    public labSubmissionIdSubject = new BehaviorSubject<number>(null);
    labSubmissionId$ = this.labSubmissionIdSubject.asObservable();
    public labAnalysisTypeSubject = new BehaviorSubject<BasicLabManagerItemModel[]>(null);
    labAnalysisType$ = this.labAnalysisTypeSubject.asObservable();

    public labAnalysisCostItemsTriggerSubject = new BehaviorSubject<LabCostItemModel[]>(null);
    
    private labSubmissionDetailsSubject = new BehaviorSubject<any | null>(null);
    labSubmissionDetailsData$ = this.labSubmissionDetailsSubject.asObservable();

    private isApproverSubject = new BehaviorSubject<any | null>(null);
    isApproverData$ = this.isApproverSubject.asObservable();

    updateApprover(data: boolean) {
        this.isApproverSubject.next(data);
    }

    updateLabSubmissionDetails(data: any) {
        this.labSubmissionDetailsSubject.next(data);
    }

    updateLabAnalysisCostItems(analysisCostItem: LabCostItemModel[]) {
        this.labAnalysisCostItemsTriggerSubject.next(analysisCostItem);
    }

     getLabSubmissionDetails(): any | null {
        return this.labSubmissionDetailsSubject.getValue();
    }

    getLabAnalysisTypes(): BasicLabManagerItemModel[] {
        return this.labAnalysisTypeSubject.getValue();
    }
}
